export default "__VITE_ASSET__375e5ec4__"